import { Filesystem, Directory } from '@capacitor/filesystem';

/**
 * Download and cache image locally
 */
export const cacheImage = async (imageUrl, fileName) => {
    try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const reader = new FileReader();

        reader.onloadend = async () => {
            const base64data = reader.result.split(',')[1];

            await Filesystem.writeFile({
                path: `images/${fileName}`,
                data: base64data,
                directory: Directory.Data
            });
        };

        reader.readAsDataURL(blob);
    } catch (error) {
        console.error('Failed to cache image:', error);
    }
};

/**
 * Load cached image if available, otherwise return null
 */
export const loadCachedImage = async (fileName) => {
    try {
        const file = await Filesystem.readFile({
            path: `images/${fileName}`,
            directory: Directory.Data
        });

        return `data:image/png;base64,${file.data}`;
    } catch (error) {
        console.warn('Image not found in cache:', fileName);
        return null;
    }
};